import { render, staticRenderFns } from "./Edit_cardtemplate.vue?vue&type=template&id=2515d1b7"
import script from "./Edit_cardtemplate.vue?vue&type=script&lang=js"
export * from "./Edit_cardtemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports